import type { RedcatAnalyticsStore } from '../types/store';
import { SigninTrackEventName } from '../types/signin';
import type { SigninErrorType } from '../types/signin';
import type { SigninTrackEvent } from '../types/events/track';

export const trackSigninFailed = (
  track: RedcatAnalyticsStore['track'],
  { errorType }: { errorType: SigninErrorType },
) => {
  const event: SigninTrackEvent = {
    name: SigninTrackEventName.Failed,
    properties: {
      error_type: errorType,
    },
  };

  track(event);
};
